export default [
  {
    title: 'Alerts',
    icon: { icon: 'lucide:bell-ring' },
    action: 'read',
    subject: 'User',
    envOnly: 'development',
    children: [
      {
        title: 'Dashboard',
        to: 'alerts-dashboard',
        action: 'read',
        subject: 'User',
        envOnly: 'development',
        icon: { icon: 'lucide:layout-dashboard' },
      },
      {
        title: 'Settings',
        to: 'alerts-settings',
        action: 'read',
        subject: 'User',
        envOnly: 'development',
        icon: { icon: 'ic:outline-settings' },
      },
    ],
  },
];
